export default __webpack_public_path__ + "static/media/useCouponCodellustrator.f2d1e5a9.svg";